import LPanel from './src/main'

/* istanbul ignore next */
LPanel.install = function(Vue) {
  Vue.component(LPanel.name, LPanel)
}

export default LPanel
